// extracted by mini-css-extract-plugin
module.exports = {"center":"_24P-B","left":"EB3i_","right":"_20oUw"};